import script from "./landlord-details-landlord-switch.vue?vue&type=script&setup=true&lang=ts"
export * from "./landlord-details-landlord-switch.vue?vue&type=script&setup=true&lang=ts"

import "./landlord-details-landlord-switch.vue?vue&type=style&index=0&id=c8290e62&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8290e62"]])

export default __exports__